export default __webpack_public_path__ + "static/media/2503287.528963e4.jpg";